import CurrentMethodInfo from './CurrentMethodInfo';

export default CurrentMethodInfo;